import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { FullscreenContainer } from './components/container/fullscreen-container';
import { RedirectUnauthorizedContainer } from './components/routing/redirect-unauthorized-container';
import { AuthProvider } from './hooks/use-auth';
import { ToastsProvider } from './hooks/use-toasts';
import { Dashboard, Home, Login, MindmapEditor, NotFound, Register } from './pages';

export const App = () => {
  return (
    <ToastsProvider>
      <AuthProvider>
        <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="maps" element={<RedirectUnauthorizedContainer />}>
              <Route index element={<Dashboard />} />
              <Route path=":id" element={<MindmapEditor />} />
            </Route>
            <Route path="/" element={<FullscreenContainer />}>
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ToastsProvider>
  );
};
